export enum CertificateMessages {
  activeText = "global.activeText"
}

export interface TranslationCertificateMessages {
  [CertificateMessages.activeText]: string;
}
